<template>
  <footer class="footer">
    <p>For demonstration purposes only. © 2026 Vivamo Inc.</p>
  </footer>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style scoped>
.footer {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: var(--card-background);
  text-align: center;
  padding: 0.9rem;
  border-top: 1px solid var(--accent-color);
  z-index: 1000;
}

.footer p {
  margin: 0;
  color: var(--text-color);
  font-size: 0.9rem;
}

/* Mobile responsive styles for footer */
@media (max-width: 768px) {
  .footer {
    padding: 0.8rem 1rem;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    width: auto;
  }

  .footer p {
    font-size: 0.8rem;
    line-height: 1.3;
  }
}

@media (max-width: 480px) {
  .footer {
    padding: 0.7rem 0.8rem;
  }

  .footer p {
    font-size: 0.75rem;
    line-height: 1.2;
  }
}

@media (max-width: 360px) {
  .footer {
    padding: 0.6rem 0.5rem;
  }

  .footer p {
    font-size: 0.7rem;
  }
}

/* Landscape mobile orientation */
@media (max-width: 768px) and (orientation: landscape) {
  .footer {
    padding: 0.5rem 1rem;
  }

  .footer p {
    font-size: 0.7rem;
  }
}
</style>
